import { createTheme } from "@mui/material";

// The custom theme provided by the user. It is crucial for the app's look and feel.
export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#ff9800",
      contrastText: "#fff",
    },
    scraptradeYellow: {
      main: "#F4C542",
      dark: "#E3AE27",
    },
    scraptradeDark: {
      main: "#2D2D2D",
    },
    background: {
      default: "#f4f6f8",
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          paddingTop: "12px",
          paddingBottom: "12px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#f0f4f9",
          borderRadius: "8px",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#F4C542",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E3AE27",
          },
          "&.Mui-focused .MuiInputBase-input::placeholder": {
            color: "#E3AE27",
            opacity: 1,
          },
          "&.Mui-focused .MuiInputLabel-root": {
            color: "#E3AE27",
          },
        },
        notchedOutline: {
          borderColor: "transparent",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#E3AE27",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: "#f0f4f9",
          borderRadius: "8px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#F4C542",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#F4C542",
          },
        },
      },
    },
  },
});
